import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Helmet } from "react-helmet";
import {
  faMobileAlt,
  faBolt,
  faDownload,
} from "@fortawesome/free-solid-svg-icons";

const Hero = () => {
  return (
    <React.Fragment>
      <Helmet>
        <title>Topup Connect</title>
        <meta
          name="description"
          content="Your trusted partner for mobile recharge, bill payments and digital services"
        />
      </Helmet>

      <section
        id="home"
        className="hero"
        style={{
          background:
            "linear-gradient(135deg,rgb(61, 206, 109) 0%,rgb(49, 206, 177) 100%)",
          color: "#fff",
          padding: "120px 20px",
          textAlign: "center",
        }}
      >
        <div
          className="container"
          style={{ maxWidth: "960px", margin: "0 auto" }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              fontSize: "3.5rem",
              marginBottom: "25px",
              gap: "20px",
            }}
          >
            <FontAwesomeIcon icon={faMobileAlt} />
            <FontAwesomeIcon icon={faBolt} />
          </div>
          <h1
            style={{
              fontSize: "2.5rem",
              fontWeight: "800",
              marginBottom: "20px",
            }}
          >
            Fast, Secure & Reliable Recharge Services
          </h1>
          <p
            style={{
              fontSize: "1.25rem",
              marginBottom: "35px",
              maxWidth: "700px",
              margin: "0 auto",
            }}
          >
            Experience lightning-fast mobile recharge, DTH, and bill payments –
            anytime, anywhere.
          </p>
          {/* App Download Button */}
          <div style={{ marginTop: "30px" }}>
            <a
              href="https://play.google.com/store/apps/details?id=com.topupconnect.topupconnectindia"
              target="_blank"
              rel="noopener noreferrer"
              style={{
                display: "inline-flex",
                alignItems: "center",
                backgroundColor: "#000",
                color: "#fff",
                padding: "12px 20px",
                borderRadius: "6px",
                textDecoration: "none",
                fontWeight: "500",
                fontSize: "1rem",
                gap: "10px",
              }}
            >
              <FontAwesomeIcon icon={faDownload} />
              Download App on Play Store
            </a>
          </div>
        </div>
      </section>
    </React.Fragment>
  );
};

export default Hero;
